export enum presets {
  WINEGLASS = 'wineglass',
}

export const presetAssets = {
  [presets.WINEGLASS]: 'Wine-Glass_Color-Change.gif',
} as { [name: string]: string };
